Auth = require('app/scripts/db/auth')

module.exports =
  getFilteredActionsCount: (model) ->
    showDetails = !Auth.isLoggedIn() || Auth.me().getShowDetails()
    filteredActions = model.actionList.filter (action) ->
      if showDetails
        true
      else
        action.isCommentLike()

    return filteredActions.length
